class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key || (parsedState.items && parsedState.items.length > 0 ? parsedState.items[0].key : '');
    
    this.getSectionsToRender().forEach((section) => {
      const targetEl = document.getElementById(section.id);
      if (!targetEl || !parsedState.sections || !parsedState.sections[section.id]) return;
      
      const html = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
      if (html) {
        targetEl.innerHTML = html;
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: this.cartItemKey ? `[id="cart-notification-product-${this.cartItemKey}"]` : '.cart-item',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    let el = selector ? doc.querySelector(selector) : null;
    if (!el && selector && selector.indexOf('cart-notification-product') !== -1) {
      el = doc.querySelector('.cart-item') || doc.querySelector('#cart-notification-product') || doc.querySelector('.shopify-section');
    }
    if (!el) el = selector ? doc.querySelector(selector) : doc.querySelector('.shopify-section');
    if (!el) el = doc.body;
    return el ? el.innerHTML : (doc.body ? doc.body.innerHTML : '');
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
